'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosReload = function IoIosReload(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm15 5c8.3 0 15 6.7 15 15l4.3-4.1 0.7 0.7-5.5 5.3-5.2-5.3 0.7-0.7 4 4c0-7.6-6.3-13.9-14-13.9s-14 6.3-14 14 6.3 14 14 14c6.2 0 11.4-3.9 13.3-9.5l0.9 0.3c-2 5.9-7.6 10.2-14.2 10.2-8.3 0-15-6.7-15-15s6.7-15 15-15z' })
        )
    );
};

exports.default = IoIosReload;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-reload.js
// module id = 2751
// module chunks = 168707334958949